import MenuOptions from "../../components/order/menu/MenuOptions";

export default function PointsBadgesMenu({ order, mobile, onDelete, onEdit }) {
  const menu = [
    {
      label: "Edit badge",
      action: () => {
        onEdit?.();
      },
      visible: true,
    },
    {
      label: "Delete badge",
      action: () => {
        onDelete?.();
      },
      visible: true,
    },
  ];

  return (
    <>
      <div className="hidden"></div>
      <MenuOptions mobile={mobile} menu={menu} />
    </>
  );
}
// Stay menu
